module.exports = __webpack_public_path__ + "img/elementaryPOS.c5ad1a9b.svg";